import { render } from "./FormProfissionalTerceirizado.vue?vue&type=template&id=6a753cc6&scoped=true"
import script from "./FormProfissionalTerceirizado.vue?vue&type=script&lang=js"
export * from "./FormProfissionalTerceirizado.vue?vue&type=script&lang=js"

import "./FormProfissionalTerceirizado.vue?vue&type=style&index=0&id=6a753cc6&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a753cc6"]])

export default __exports__